import React from 'react';
import CardActionArea, {
  CardActionAreaProps,
} from '@material-ui/core/CardActionArea';

const CardActionAreaNext: React.FC<CardActionAreaProps> = props => (
  <CardActionArea {...props} />
);

export default CardActionAreaNext;
